module.exports = __webpack_public_path__ + "static/media/ticketSignatureCanceled.28dfa47a.svg";